<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; flex-direction: column">
      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 900px; margin-top: 10px;">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>System Maintenance</div>
        </div>
        <div style="margin: 20px">
          <div>
            {{siteInfo?.maintenance_message}}
          </div>
          <div style="margin-top: 10px">
            <dx-button text="Retry" (onClick)="retry()" icon="{{ env.assetsPath }}images/Refresh_16x16.png"></dx-button>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
